<ami-dialog-message [setting]="message"></ami-dialog-message>

<pg-product-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-product-create>

<pg-product-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-product-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
